<template lang='pug'>
  .product-heart
    template(v-if='!!currentUser')
      template(v-if='isWishlisted')
        a.add-to-wish-list(href='/wishlist')
          .wish-list-icon.svg-icon(:class='inProductCard ? "product-card-heart-filled" : "heart-fill"')
          .wish-list-text(v-if='withText' v-t='"buttons.addedToWishlist"')
      template(v-else)
        a.add-to-wish-list(@click.prevent='addToWishList' href='#')
          .wish-list-icon.svg-icon(:class='inProductCard ? "product-card-heart" : "heart-empty"')
          .wish-list-text(v-if='withText' v-t='"buttons.addToWishlist"')
    template(v-else)
      router-link.add-to-wish-list(:to='{ query: { ...$router.currentRoute.query, wishlist: variantId }, hash: "authentication" }' append replace)
        .wish-list-icon.svg-icon(:class='inProductCard ? "product-card-heart" : "heart-empty"')
        .wish-list-text(v-if='withText' v-t='"buttons.addToWishlist"')

</template>

<i18n>
{
  "lng_en": {
    "addedToWishlist": "%{productName} has been added to your Wish List"
  },
  "lng_id": {
    "addedToWishlist": "%{productName} ditambahkan ke Wish List"
  },
  "lng_th": {
    "addedToWishlist": "เพิ่ม %{productName} ในรายการสินค้าที่อยากได้แล้ว"
  },
  "lng_zh": {
    "addedToWishlist": "%{productName}已被添加至願望清單"
  },
  "lng_ko": {
    "addedToWishlist": "%{productName}을(를) 위시리스트에 담았습니다. "
  }
}
</i18n>

<script>
import { mapState, mapMutations } from 'vuex'
import { notifyBugsnag } from '@/modules/services/bugsnag'
import { variantUtil } from '@/mixins/variantUtil'

export default {

  mixins: [
    variantUtil
  ],

  props: {
    variant: {
      type: Object,
      default: () => { }
    },
    product: {
      type: Object,
      default: () => { }
    },
    inProductCard: {
      type: Boolean,
      default: true
    },
    withText: {
      type: Boolean,
      default: false
    },
    targetContainer: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      isWishlisted: false
    }
  },

  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser,
      wishlist: state => state.wishlist.wishlist
    }),
    userReturnTo () {
      if (this.$route.meta.returnTo) {
        return `&return_to=${this.$route.path}`
      } else {
        return ''
      }
    },
    variantId () {
      return parseInt(this.variant.id)
    },
    productName () {
      return this.product.attributes.name
    }
  },

  watch: {
    variant () {
      this.setWishlistHeart()
    },
    wishlist () {
      this.setWishlistHeart()
    }
  },

  mounted () {
    this.setWishlistHeart()
  },

  methods: {
    ...mapMutations([
      'setNotification'
    ]),

    async addToWishList () {
      this.isWishlisted = true

      if (this.targetContainer === 'PDP') {
        this.recordGTMEvent('add_to_wishlist')
      }

      try {
        await this.$store.dispatch('addVariantsToWishlist', [this.variantId])
        this.setNotification({ msg: this.$t('addedToWishlist', { productName: this.productName }) })
      } catch (error) {
        this.setNotification({ msg: this.$t('notifications.error'), type: 'error' })
        this.isWishlisted = false
        notifyBugsnag(error)
      }
    },

    setWishlistHeart () {
      this.isWishlisted = this.wishlist.indexOf(this.variantId) !== -1
    }
  }
}
</script>

<style lang='scss' scoped>
  .heart-fill,
  .heart-empty {
    height: 30px;
    width: 30px;
    vertical-align: bottom;

    @include media-breakpoint-up(md) {
      height: 20px;
      width: 20px;
    }
  }

  .wish-list-text {
    @include font-weight-bold;
    font-size: 14px;
    text-transform: uppercase;
    margin-left: 5px;
    display: inline-block;
  }
</style>
